import axios, { AxiosInstance } from 'axios';

const el = document.getElementById('content-price-info-root');

const axiosClient: AxiosInstance = axios.create({
  baseURL: el?.getAttribute('data-proxy-mount-path') || '',
});

export default axiosClient;
